
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"#A6A9EB","stroke":"#A6A9EB","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 1a1 1 0 011 1v18h3V6.5a2 2 0 012-2h2a2 2 0 012 2V20h2v-7.5a2 2 0 012-2h2a2 2 0 012 2V20h2.5a1 1 0 110 2H1V2a1 1 0 011-1zm16 11.5h-2v7h2v-7zm-10-6h2v13H8v-13z"}})])
          )
        }
      }
    